import { ApiEnvironment, setAppEnvironment } from "@companion-core/shared/app/Utils/config";

export function setWebEnvironment() {
  const apiEnv: ApiEnvironment = {
    configFileName: import.meta.env.VITE_CONFIG_FILENAME,
    apiUrl: import.meta.env.VITE_API_URL,
    i18nUrl: import.meta.env.VITE_I18N_URL,
    clientId: import.meta.env.VITE_WEB_CLIENT_ID,
    clientSecret: import.meta.env.VITE_WEB_CLIENT_SECRET,
  };

  setAppEnvironment(import.meta.env.VITE_ENVIRONMENT, apiEnv);
}
